import script from "./ProcessSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessSection.vue?vue&type=script&setup=true&lang=js"

import "./ProcessSection.vue?vue&type=style&index=0&id=37d64811&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d64811"]])

export default __exports__